import { GTMEvent } from '../GTM'
import { isCartState } from './storeCartState'

export const pushCartView = (data: Record<string, unknown>): GTMEvent => {
    if (!isCartState(data)) {
        console.info('Invalid GTM cart view data')
        return { event: '' }
    }
    const { productsDetails = [], currencyCode } = data
    // Reorder items properly
    productsDetails.reverse()
    return {
        event: 'cartView',
        cartContents: {
            currencyCode,
            products: productsDetails
        },
        _clear: true
    }
}
